import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentLoader } from '../../components';
import { SubscriptionsContainer } from '../../containers';

import { useProductCatalog, useSubscriptions } from './hooks';

const SubscriptionsList = () => {
  const { t } = useTranslation(['common', 'subscriptions-manager']);

  const subscriptions = useSubscriptions();
  const productCatalog = useProductCatalog();

  useEffect(() => {
    productCatalog.initialize();
    subscriptions.initialize();
  }, []);

  return (
    <ContentLoader
      isLoading={subscriptions.isLoading || productCatalog.isLoading}
      contentReady={subscriptions.ready && productCatalog.ready}
      errorMessage={t('loading_services_error', {
        ns: 'subscriptions-manager',
      })}
      loadingError={productCatalog.error || subscriptions.error}
      onReinitialize={() => {
        productCatalog.initialize();
        subscriptions.initialize();
      }}
    >
      <>
        {productCatalog.items.map(({ id, name }) => (
          <SubscriptionsContainer
            key={id}
            catalogId={id}
            catalogName={name}
            useExpandableLayout={productCatalog.items.length > 1}
          />
        ))}
      </>
    </ContentLoader>
  );
};

export default SubscriptionsList;
